import produce from 'immer'
import { actions } from './actions'

const initialState = {
  coloresLego: {
    data: [],
    loading: false,
    error: '',
  },
  colorLego: {
    data: null,
    loading: false,
    error: '',
  },
}

export default function colorLegoReducer(state = initialState, action) {
  switch (action.type) {
    case actions.GET_ALL_COLORES_LEGO_REQUESTED: {
      return {
        ...state,
        coloresLego: { ...state.coloresLego, loading: true },
      }
    }
    case actions.GET_ALL_COLORES_LEGO_SUCCEEDED: {
      const coloresLego = action.payload
      const newState = produce(state, draftState => {
        draftState.coloresLego.data = coloresLego
        draftState.coloresLego.loading = false
      })
      return newState
    }
    case actions.GET_ALL_COLORES_LEGO_FAILED:
      return {
        ...state,
        coloresLego: {
          ...state.coloresLego,
          loading: false,
          error: action.error,
        },
      }
    case actions.INSERT_COLOR_LEGO_REQUESTED: {
      return {
        ...state,
        colorLego: { ...state.colorLego, loading: true },
        coloresLego: { ...state.coloresLego, loading: true },
      }
    }
    case actions.INSERT_COLOR_LEGO_SUCCEEDED: {
      const colorLego = action.payload
      const newState = produce(state, draftState => {
        draftState.coloresLego.data = [...draftState.coloresLego.data, colorLego].sort((a, b) =>
          a.estante.localeCompare(b.estante),
        )
        draftState.colorLego.data = colorLego
        draftState.coloresLego.loading = false
        draftState.colorLego.loading = false
      })
      return newState
    }
    case actions.INSERT_COLOR_LEGO_FAILED:
      return {
        ...state,
        coloresLego: {
          ...state.coloresLego,
          loading: false,
          error: action.error,
        },
        colorLego: {
          ...state.coloresLego,
          loading: false,
          error: action.error,
        },
      }
    case actions.UPDATE_COLOR_LEGO_REQUESTED: {
      return {
        ...state,
        colorLego: { ...state.colorLego, loading: true },
        coloresLego: { ...state.coloresLego, loading: true },
      }
    }
    case actions.UPDATE_COLOR_LEGO_SUCCEEDED: {
      const colorLego = action.payload
      const newState = produce(state, draftState => {
        draftState.colorLego.data = colorLego
        const index = draftState.coloresLego?.data?.findIndex(p => p.id === colorLego.id)
        if (index !== undefined && index !== -1) {
          draftState.coloresLego.data[index] = colorLego
        }
        draftState.coloresLego.data = draftState.coloresLego.data.sort((a, b) => a.orden - b.orden)
        draftState.coloresLego.loading = false
        draftState.colorLego.loading = false
      })
      return newState
    }
    case actions.UPDATE_COLOR_LEGO_FAILED:
      return {
        ...state,
        colorLego: {
          ...state.colorLego,
          loading: false,
          error: action.error,
        },
        coloresLego: {
          ...state.colorLego,
          loading: false,
          error: action.error,
        },
      }
    case actions.UPDATE_RANGE_COLORES_LEGO_REQUESTED: {
      return {
        ...state,
        coloresLego: { ...state.coloresLego, loading: true },
      }
    }
    case actions.UPDATE_RANGE_COLORES_LEGO_SUCCEEDED: {
      const coloresLego = action.payload
      const newState = produce(state, draftState => {
        // eslint-disable-next-line no-unused-expressions
        coloresLego?.forEach(colorLego => {
          const index = draftState.coloresLego?.data?.findIndex(p => p.id === colorLego.id)
          if (index !== undefined && index !== -1) {
            draftState.coloresLego.data[index] = colorLego
          }
        })
        draftState.coloresLego.data = draftState.coloresLego.data.sort((a, b) =>
          a.estante.localeCompare(b.estante),
        )
        draftState.coloresLego.loading = false
      })
      return newState
    }
    case actions.UPDATE_RANGE_COLORES_LEGO_FAILED:
      return {
        ...state,
        coloresLego: {
          ...state.coloresLego,
          loading: false,
          error: action.error,
        },
      }
    case actions.DELETE_COLOR_LEGO_REQUESTED: {
      return {
        ...state,
        coloresLego: { ...state.coloresLego, loading: true },
      }
    }
    case actions.DELETE_COLOR_LEGO_SUCCEEDED: {
      const colorLegoId = action.payload
      const newState = produce(state, draftState => {
        draftState.coloresLego.data = draftState.coloresLego.data.filter(c => c.id !== colorLegoId)
        draftState.coloresLego.loading = false
      })
      return newState
    }
    case actions.DELETE_COLOR_LEGO_FAILED:
      return {
        ...state,
        coloresLego: {
          ...state.coloresLego,
          loading: false,
          error: action.error,
        },
      }
    case actions.SELECTED_COLOR_LEGO_BY_ID: {
      const colorLego = action.payload
      const newState = produce(state, draftState => {
        draftState.colorLego.data = colorLego
        draftState.colorLego.loading = false
      })
      return newState
    }

    default:
      return state
  }
}
